module.exports = __webpack_public_path__ + "static/offer-business-1-589b51d6448c19ed6b1803449bf4e2e9.png";